import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38129941"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "按包名＋名称生成，超出32位时请手工填写；保存后不可修改。", -1));
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "JPG/PNG，200×200像素，小于200KB。", -1));
const _hoisted_10 = {
  class: "card"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "仅支持1至10000之间的整数。", -1));
const _hoisted_13 = {
  class: "submitBlock"
};
const _hoisted_14 = {
  key: 0,
  class: "selectBox"
};
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { getNode } from '@/common';
import { addGoods, updGoods, queryGoods, queryPkgInfo, translator, uploadMallImage } from '@/api/goodsSetting';
import useDetailHooks from '../hooks/useDetailHooks';
import RecordDrawer from './RecordDrawer.vue';
import { generateMallProductId, validateMallProduct, isMallPriceInsertionAllowed, validateMallImage } from '../services/weixinMall';
export default /*#__PURE__*/_defineComponent({
  __name: 'WeixinMallDetail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      huaweiProdTypeOptions
    } = useDetailHooks();
    const dbtId = String(route.query.dbtId || '');
    const id = route.query.id ? Number(route.query.id) : undefined;
    const readonly = route.query.type === 'watch';
    const context = {
      dbtId,
      prodChnl: 'weixin',
      productScene: 'MALL'
    };
    const form = ref({
      prodName: '',
      prodId: '',
      remark: '',
      prodPrice: null
    });
    const pkg = ref('');
    const image = ref();
    const saving = ref(false);
    const initializing = ref(true);
    const uploading = ref(false);
    const allowPriceInsertion = (event, inserted) => {
      var _input$selectionStart, _input$selectionEnd;
      const input = event.target;
      if (!isMallPriceInsertionAllowed(input.value, (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : input.value.length, (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : input.value.length, inserted)) {
        event.preventDefault();
        message.error('价格仅支持1至10000之间的整数，请检查输入内容');
      }
    };
    const guardPriceInput = event => {
      if (event.inputType.startsWith('insert') && event.data !== null) allowPriceInsertion(event, event.data);
    };
    const guardPricePaste = event => {
      var _event$clipboardData;
      allowPriceInsertion(event, ((_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text')) || '');
    };
    const saveNext = ref(false);
    const previewVisible = ref(false);
    const recordVisible = ref(false);
    const fileList = computed(() => image.value ? [{
      uid: image.value.objectKey,
      name: '商品图片',
      status: 'done',
      url: image.value.imageUrl
    }] : []);
    const back = () => router.push({
      name: 'goodsSetting',
      query: context
    });
    const removeImage = () => {
      image.value = undefined;
      form.value.mallImageObjectKey = '';
      return true;
    };
    const upload = async options => {
      uploading.value = true;
      try {
        var _options$onSuccess;
        const error = await validateMallImage(options.file);
        if (error) throw new Error(error);
        const data = new FormData();
        data.append('dbtId', dbtId);
        data.append('file', options.file);
        const response = await uploadMallImage(data);
        if (String(response === null || response === void 0 ? void 0 : response.code) !== '0') throw new Error((response === null || response === void 0 ? void 0 : response.msg) || '图片上传失败');
        image.value = response.data;
        form.value.mallImageObjectKey = response.data.objectKey;
        (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, response.data);
      } catch (error) {
        var _options$onError;
        message.error(error instanceof Error ? error.message : '图片上传失败');
        (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
      } finally {
        uploading.value = false;
      }
    };
    const generateId = async () => {
      var _form$value$prodName;
      form.value.prodName = (_form$value$prodName = form.value.prodName) === null || _form$value$prodName === void 0 ? void 0 : _form$value$prodName.trim();
      if (id || !form.value.prodName || form.value.prodId && form.value.prodId !== pkg.value) return;
      const name = form.value.prodName;
      const initialId = form.value.prodId;
      try {
        const response = await translator({
          sourceLang: 'zh-cn',
          sourceText: name,
          targetLang: ['en_Us']
        });
        if (String(response === null || response === void 0 ? void 0 : response.code) === '0' && form.value.prodName === name && form.value.prodId === initialId) {
          form.value.prodId = generateMallProductId(pkg.value, response.data.translateList[0].translatedResult);
          if (form.value.prodId.length > 32) message.warning('自动生成的内购ID超过32位，请手工填写合法短ID');
        }
      } catch (error) {
        message.warning('内购ID生成失败，请手工填写');
      }
    };
    const save = async () => {
      if (saving.value || uploading.value || initializing.value) return;
      const error = validateMallProduct(form.value);
      if (error) return message.warning(error);
      if (form.value.prodId === pkg.value) return message.warning('内购ID不可完全等于包名，请手动补齐');
      saving.value = true;
      try {
        const response = await (id ? updGoods : addGoods)({
          ...form.value,
          ...context,
          id,
          pkg: pkg.value,
          os: 0,
          prodPrice: String(form.value.prodPrice),
          prodPriceCurrency: 'CNY',
          syncCreateIosPlatProd: false
        });
        if (String(response === null || response === void 0 ? void 0 : response.code) !== '0') return;
        message.success('商品保存成功！');
        if (id || !saveNext.value) await back();else {
          form.value = {
            prodType: form.value.prodType,
            prodPrice: null,
            prodName: '',
            prodId: pkg.value,
            remark: ''
          };
          image.value = undefined;
        }
      } finally {
        saving.value = false;
      }
    };
    onMounted(async () => {
      try {
        if (id) {
          const response = await queryGoods({
            ...context,
            id
          });
          if (String(response === null || response === void 0 ? void 0 : response.code) === '0') {
            var _response$data$mallIm;
            form.value = {
              ...response.data,
              prodPrice: Number(response.data.prodPrice),
              mallImageObjectKey: (_response$data$mallIm = response.data.mallImage) === null || _response$data$mallIm === void 0 ? void 0 : _response$data$mallIm.objectKey
            };
            image.value = response.data.mallImage;
            pkg.value = response.data.pkg;
          }
        } else {
          const response = await queryPkgInfo(context);
          if (String(response === null || response === void 0 ? void 0 : response.code) === '0') {
            pkg.value = response.data.pkg;
            form.value.prodId = pkg.value;
          }
        }
      } finally {
        initializing.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_image = _resolveComponent("a-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        "label-col": {
          style: 'width: 120px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createTextVNode(" 商城道具配置 "), _unref(id) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "record-text",
          onClick: _cache[0] || (_cache[0] = $event => recordVisible.value = true)
        }, "变更记录")) : _createCommentVNode("", true)]), _createVNode(_component_a_form_item, {
          label: "商品类型",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: form.value.prodType,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => form.value.prodType = $event),
            class: "inputer",
            options: _unref(huaweiProdTypeOptions),
            disabled: Boolean(_unref(id)) || readonly,
            placeholder: "请选择商品类型",
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品名称",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: form.value.prodName,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => form.value.prodName = $event),
            class: "bigInputer",
            disabled: readonly,
            placeholder: "请输入商品名称，最多10字",
            onBlur: generateId
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "内购ID",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: form.value.prodId,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => form.value.prodId = $event),
            class: "bigInputer",
            disabled: Boolean(_unref(id)) || readonly,
            placeholder: "请输入内购ID，最多32位"
          }, null, 8, ["value", "disabled"]), _hoisted_7]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品图片",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_upload, {
            "file-list": _unref(fileList),
            "list-type": "picture-card",
            accept: "image/jpeg,image/png",
            "max-count": 1,
            disabled: readonly || uploading.value,
            "custom-request": upload,
            onRemove: removeImage,
            onPreview: _cache[4] || (_cache[4] = $event => previewVisible.value = true)
          }, {
            default: _withCtx(() => [!form.value.mallImageObjectKey ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(uploading.value ? '上传中' : '上传图片'), 1)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["file-list", "disabled"]), _hoisted_9]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: form.value.remark,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => form.value.remark = $event),
            class: "bigInputer",
            disabled: readonly,
            placeholder: "请输入备注，最多50字"
          }, null, 8, ["value"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_form_item, {
          label: "默认价格",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: form.value.prodPrice,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => form.value.prodPrice = $event),
            class: "priceInputer",
            style: {
              "width": "200px"
            },
            "addon-after": "CNY",
            placeholder: "请输入默认价格",
            disabled: readonly,
            inputmode: "numeric",
            onBeforeinput: guardPriceInput,
            onPaste: guardPricePaste
          }, null, 8, ["value"]), _hoisted_12]),
          _: 1
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(readonly ? '返 回' : '取 消'), 1)]),
        _: 1
      }), !readonly ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_a_button, {
        type: "primary",
        class: "ml8",
        loading: saving.value,
        disabled: uploading.value || initializing.value,
        onClick: save
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), !_unref(id) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[7] || (_cache[7] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", null, [image.value ? (_openBlock(), _createBlock(_component_a_image, {
        key: 0,
        src: image.value.imageUrl,
        preview: {
          visible: previewVisible.value,
          onVisibleChange: visible => previewVisible.value = visible
        }
      }, null, 8, ["src", "preview"])) : _createCommentVNode("", true)], 512), [[_vShow, false]]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"])]);
    };
  }
});